// Rails entry point — `react_component 'Invoices/PaymentLifecycleIcons',
// event: latest, history: [...]`.
//
// The implementation lives in PaymentLifecycleIconsView.tsx (NOT named after
// the directory). Webpack's `require.context` resolution treated a sibling
// file named after its parent directory as a self-import, producing an
// undefined export at runtime — naming the sibling distinctly avoids that.
import React from 'react';
import { PaymentLifecycleIconsView } from './PaymentLifecycleIconsView';
export default function Index({ event, history }) {
    return React.createElement(PaymentLifecycleIconsView, { event: event, history: history });
}
